import type { ReactNode } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

type InfoItemVariant = 'default' | 'danger'

interface Props {
  title: string
  subtitle?: ReactNode
  icon?: AllIcons
  iconImage?: string
  actionRight?: ReactNode
  onClick?: () => void
  className?: string
  hasArrow?: boolean
  variant?: InfoItemVariant
}

export const InfoItem = ({
  title,
  subtitle,
  icon,
  iconImage,
  actionRight,
  onClick,
  className,
  hasArrow = true,
  variant = 'default',
}: Props) => {
  const hasActionRight = actionRight !== undefined && actionRight !== null

  return (
    <div
      className={clsx(s.container, s[variant], className)}
      onClick={onClick}
    >
      {icon ? (
        <AppIcon
          id={icon}
          width={24}
          height={24}
          className={s.icon}
        />
      ) : iconImage ? (
        <div className={s.iconImageWrapper}>
          <img
            src={iconImage}
            alt={title}
            className={s.iconImage}
          />
        </div>
      ) : null}

      <div className={s.box}>
        <div className={s.info}>
          <p className={clsx('semi-bold-14', s.title)}>{title}</p>
          {subtitle && (
            <p className={clsx('medium-13', s.subtitle)}>{subtitle}</p>
          )}
        </div>

        {hasActionRight ? (
          <div
            className={s.actionRight}
            onClick={(event) => event.stopPropagation()}
          >
            {actionRight}
          </div>
        ) : (
          hasArrow && (
            <AppIcon
              id={AllIcons.CHEVRON_RIGHT}
              width={16}
              height={16}
              className={s.chevron}
            />
          )
        )}
      </div>
    </div>
  )
}
